const BASE_URL = "https://todooos-api.onrender.com";

export {BASE_URL};